import React from 'react'
import { MessageCircle } from 'lucide-react'

import { SOCIAL_TELEGRAM_URL, SOCIAL_X_URL } from '../../constants/socialLinks'
import { useTranslation } from '@/features/locale/LocaleProvider'
import { Button } from '@/ui/button'

function XIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  )
}

export function HomeCoreExperiences() {
  const t = useTranslation()

  return (
    <section className="mobile-app__info-panel space-y-4 px-4 py-5 sm:px-5">
      <div className="space-y-1 text-center sm:text-left">
        <p className="mobile-app__info-kicker">{t.home.joinConversation}</p>
        <p className="mobile-app__body-text text-muted-foreground">{t.home.joinLead}</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <a
          href={SOCIAL_X_URL}
          target="_blank"
          rel="noreferrer"
          className="mobile-app__card flex flex-col items-center gap-4 p-6 text-center transition-opacity hover:opacity-90"
        >
          <span className="inline-flex size-14 items-center justify-center rounded-2xl bg-primary/15 text-primary">
            <XIcon className="size-7" />
          </span>
          <span className="mobile-app__body-text font-semibold">X</span>
          <Button variant="outline" size="lg" className="min-h-11 w-full pointer-events-none">
            {t.home.followX}
          </Button>
        </a>
        <a
          href={SOCIAL_TELEGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className="mobile-app__card flex flex-col items-center gap-4 p-6 text-center transition-opacity hover:opacity-90"
        >
          <span className="inline-flex size-14 items-center justify-center rounded-2xl bg-primary/15 text-primary">
            <MessageCircle className="size-7" />
          </span>
          <span className="mobile-app__body-text font-semibold">Telegram</span>
          <Button size="lg" className="min-h-11 w-full pointer-events-none">
            {t.home.joinTelegram}
          </Button>
        </a>
      </div>
    </section>
  )
}
